var util = require('js/lib/util');
var editRoutePlanTemplate = require('html/templates/editRoutePlan')();
var t = require('js/lib/translate').t;

edit.$inject = ['$rootScope', '$window', '$filter', 'load', 'modal'];

function edit($rootScope, $window, $filter, load, modal) {

  this.openEditRoutePlan = function($scope, routePlan, distribution, routePlans) {
    var editRoutePlan = { distrNo: 0 };
    if (routePlan) {
      editRoutePlan.id = routePlan.id;
      editRoutePlan.name = routePlan.name;
      editRoutePlan.date = routePlan.date;
      editRoutePlan.distrNo = routePlan.distrNo;
    }

    if ($scope.distribution != null && $scope.distribution.routePlans && $scope.distribution.routePlans[0]) {
      editRoutePlan.date = $scope.distribution.routePlans[0].date;
      editRoutePlan.distrNo = $scope.distribution.routePlans[0].distrNo;
    }

    if (distribution || $scope.distribution != null) {
      $scope.showCompany = true;
      if($scope.settings.companies.length == 1) {
        editRoutePlan.companyId = $scope.settings.companies[0].id;
      }
    }

    $scope.editRoutePlan = editRoutePlan;
    modal.open({
      scope: $scope,
      klass: 'edit-route-plan',
      title: distribution ? t('distributionModalNew') : t(routePlan ? 'planModalHeaderEdit' : 'planModalHeaderNew'),
      body: editRoutePlanTemplate
    });
  };

  this.saveRoutePlan = function($scope, routePlan) {
    routePlan.date = util.toDateNoon(routePlan.date);

    if (routePlan.id) {
      load.saveRoutePlan(routePlan).then(function() {
        $window.location.reload(true);
      });
    } else {
      if ($scope.editRoutePlan.companyId) {
        routePlan.companyId = $scope.editRoutePlan.companyId;
      } else {
        routePlan.companyId = $rootScope.auth.companyId;
      }

      load.saveRoutePlan(routePlan).then(function(data) {
        $window.location.assign($scope.router.link('plan/files', data.id));
      });
    }
  };

  this.deleteRoutePlan = function($scope, routePlan) {
    var name = $filter('moment')(routePlan.date, 'LL') +
      (routePlan.name ? (', ' + routePlan.name) : '');

    modal.open({
      scope: $scope,
      title: t('planDeletePlan'),
      body: t('planDeletePlanConfirm', name),
      onConfirm: function() {
        load.deleteRoutePlan(routePlan.id);
      }
    });
  };
}

module.exports = edit;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/editRoutePlan.js
 ** module id = 197
 ** module chunks = 1
 **/